// Auto-extracted from Profile.jsx
import { useState, useEffect, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Btn } from "../../components/Btn";
import { Eyebrow } from "../../components/Eyebrow";
import { Icon } from "../../components/Icon";
import { Skeleton } from "../../components/Skeleton";
import { EmptyState } from "../../components/EmptyState";
import { ProductCard } from "../../components/ProductCard";
import { supabase } from "../../lib/supabase";
import { fmtK } from "../../lib/money";
import { useWishlist } from "../../store/wishlistStore";
import { getAllLocations } from "../../data/zambianLocations";
import { timeAgo } from "../../lib/dateUtils";
import { useCategories } from "../../hooks/useCategories";
import { BecomeSellerModal } from "../../components/BecomeSellerModal";
import { PhoneVerificationModal } from "../../components/PhoneVerificationModal";
import { DeleteAccountModal } from "../../components/DeleteAccountModal";
import { Field, SecurityRow, InfoRow, inputStyle } from "./shared";
import { LinkRow } from "./uiHelpers";

export function AboutPanel() {
  return (
    <Card pad={22}>
      <Eyebrow>About Kapio</Eyebrow>
      <div style={{ fontSize: 14, fontWeight: 900, color: C.charcoal, marginTop: 10 }}>
        Shop local. Sell smart. All in one place.
      </div>
      <p style={{ fontSize: 13, color: C.slate, lineHeight: 1.6, marginTop: 8 }}>
        Kapio is a mobile-first marketplace built for Zambian university students — a trusted home for everything that
        used to happen over WhatsApp. Secure mobile-money checkout, buyer-protected escrow, and seller analytics, all in
        one place.
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 14, marginTop: 14 }}>
        <LinkRow icon="globe" title="Website" body="kapio.pages.dev" href="https://kapio.pages.dev" external />
        <LinkRow icon="shield" title="Privacy Policy" body="kapio-apps.pages.dev/privacy.html" href="https://kapio-apps.pages.dev/privacy.html" external />
        <LinkRow icon="file-text" title="Terms of Service" body="kapio-apps.pages.dev/terms.html" href="https://kapio-apps.pages.dev/terms.html" external />
        <LinkRow icon="mail" title="Support" body="support@kapio.co.zm" href="mailto:support@kapio.co.zm" />
      </div>
      <div style={{ fontSize: 11, color: C.muted, marginTop: 16, textAlign: "center" }}>
        Kapio v1.0.0 · Made in Zambia
      </div>
    </Card>
  );
}
